import React, { useRef, useState } from 'react';
import { observer } from 'mobx-react';
import { StepIndicatorVM, IStepIndicatorProps } from './StepIndicatorVM';
import './StepIndicator.scss';
import 'uswds/dist/css/uswds.css';

import { useEffect } from 'react';

const StepIndicatorComponent = (props: IStepIndicatorProps) => {
  const vm = useRef(new StepIndicatorVM()).current;
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1300);
  const { currentStep, stepList } = props;
  useEffect(() => {
    window.addEventListener(
      'resize',
      () => {
        const ismobile = window.innerWidth < 1300;
        if (ismobile !== isMobile) setIsMobile(ismobile);
      },
      false
    );
  }, [isMobile]);

  return (
    <>
      {!isMobile ? (
        <div
          className={currentStep === 'Results' ? 'step-indicator-results' : 'step-indicator'}
          role="region"
          aria-label="Step Indicator"
        >
          <div className="display-flex justify-content-between header-links-container">
            {stepList.map((step, i) => {
              return (
                <span key={stepList[i]} className={vm.getClassNames(currentStep, stepList[i], stepList)}>
                  {currentStep === stepList[i] && <span className="usa-sr-only">Current step </span>}
                  <span aria-label={step}>{step}</span>
                  {stepList.indexOf(currentStep) > i && <span className="usa-sr-only"> completed</span>}
                  {stepList.indexOf(currentStep) < i && <span className="usa-sr-only"> not completed</span>}
                </span>
              );
            })}
          </div>
          <div role="status">
            <span className="usa-sr-only">{vm.getCurrentStatus(currentStep, stepList)}</span>
          </div>
        </div>
      ) : (
        <div
          className="usa-step-indicator step-indicator display-flex justify-content-center"
          role="region"
          aria-label="Step Indicator"
        >
          <ol className="usa-step-indicator__segments justify-content-between header-links-container">
            {stepList.map((step, i) => {
              return (
                <li key={stepList[i]} className={vm.getClassNamesMobile(currentStep, stepList[i], stepList)}>
                  <span className="usa-step-indicator__segment-label">
                    {currentStep === stepList[i] && <span className="usa-sr-only">Current step </span>}
                    {step}
                    {stepList.indexOf(currentStep) > i && <span className="usa-sr-only"> completed</span>}
                    {stepList.indexOf(currentStep) < i && <span className="usa-sr-only"> not completed</span>}
                  </span>
                </li>
              );
            })}
          </ol>
          <div role="status">
            <span className="usa-sr-only">{vm.getCurrentStatus(currentStep, stepList)}</span>
          </div>
        </div>
      )}
    </>
  );
};

export const StepIndicator = observer(StepIndicatorComponent);
